import ProjectList from "@components/modules/projects/list";
import { NotFoundClient } from "@components/widgets/ErrorPage";
import {
  ProjectsWhereColumn,
  useGetClientQuery,
} from "@src/__generated__/graphql";
import { PageLoading } from "@src/components/modules/clients/page-loading";
import { NavigationClient } from "@src/components/widgets/AppSubNav";
import { getQueryParam } from "@src/utils/routing";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import React from "react";

export const PageProjects = observer(function PageProjects() {
  const { query } = useRouter();
  const clientId = getQueryParam("id", query);

  const { data, loading } = useGetClientQuery({
    variables: { id: clientId },
  });

  if (loading) {
    return <PageLoading clientId={clientId} />;
  }

  if (!data?.client) {
    return <NotFoundClient />;
  }

  return (
    <React.Fragment>
      <ProjectList
        clientId={clientId}
        hideFilters={[ProjectsWhereColumn.BrandId]}
        pageNavigation={<NavigationClient id={clientId} variant="page" />}
      />
    </React.Fragment>
  );
});
